import { userConstants } from '../constants';

export const authActions = {
  authenticate,
  logout,
  me,
};

function authenticate(qs) {
  return (dispatch) => {
    fetch(process.env.REACT_APP_API_URL + '/auth/oauth_callback' + qs)
      .then((res) => res.json())
      .then((user) => {
        // Catch redirection
        const redir = user.redir ? user.redir : false;
        delete user.redir;
        // Store user essential data
        localStorage.setItem('scjwt', JSON.stringify(user));
        dispatch({ type: userConstants.LOGIN_SUCCESS, user });
        // Redir if neccesary
        if (redir) window.location = redir;
        // history.push(redir)
      });
  };
}

function logout() {
  return (dispatch) => {
    localStorage.removeItem('scjwt');
    dispatch({ type: userConstants.LOGOUT });
    window.location = '/admin';
  };
}

function me() {
  return (dispatch) => {
    fetch(process.env.REACT_APP_API_URL + '/auth/me', { method: 'GET' })
      .then((res) => {
        if (res.status === 401) return dispatch(authActions.logout());
        return res.json();
      })
      .then((user) => {
        console.log('User', user);
        // Store user essential data
        // localStorage.setItem('scjwt', JSON.stringify(user));
        dispatch({ type: userConstants.LOGIN_SUCCESS, user });
      });
  };
}
